import { InstagramCircle, SmsIcon, SmsIcon2, SmsIcon4 } from "components-old/icons"
import mlImg from "assets/images/channels/mercado-livre.png"
import { IChannel } from "models/channels"
import { WhatsappVersion } from "lib/constants"
import masks from "lib/masks"
import { IWorkspace } from "models/workspaces"

interface ChannelDefItem {
  type: string
  code: string
  label: string
  icon: React.ReactNode
  getProps: (
    item: IChannel,
    workspace: IWorkspace,
  ) => {
    to: string
    name?: string
    description: string
  }
}

export const channelsArray: ChannelDefItem[] = [
  {
    type: "whatsapp",
    code: "1",
    label: "WhatsApp",
    icon: (
      // <div className="fc bg-[#20ac66] rounded-full p-[5px] shrink-0 aspect-square">
      //   <IconMageWhatsapp className="text-white shrink-0 size-full" />
      // </div>
      // <div className="fc bg-[#20ac66] rounded-full p-[5px] shrink-0 aspect-square">
      //   <IconMageWhatsapp className="text-white shrink-0 size-full" />
      // </div>
      // <div className="fc bg-[#20ac66] rounded-full p-[5px] shrink-0 aspect-square">
      <IconMageWhatsappFilled className="text-[#20ac66] shrink-0 size-full" />
      // </div>
    ),
    getProps: (item) => {
      return {
        to: "/settings/channels/whatsapp" + (item?.version == WhatsappVersion.BAILEYS ? "" : "-cloud-api") + "/" + item?.id,
        name: item?.description,
        description: masks.cell(item?.phone),
        icon: <IconMageWhatsappFilled className="text-[#20ac66] shrink-0 size-full" />,
      }
    },
  },
  {
    type: "facebook",
    code: "3",
    label: "Facebook",
    icon: (
      <IconMageFacebookCircle className="text-[#0e5cdb] shrink-0 size-full" />
      // <div className="fc items-end bg-[#0e5cdb] rounded-full p-[1px] shrink-0 aspect-square overflow-hidden">
      //   <IconMageFacebook className="text-white shrink-0 size-full -mb-[5px]" />
      // </div>
      // <div className="bg-white rounded-full fc shrink-0 aspect-square">
      //   <IconMageFacebookCircle className="text-[#0866FF] shrink-0 size-full" />
      // </div>
      // <div className="fc bg-[#20ac66] rounded-full p-0.5 shrink-0 aspect-square">
      //   <IconMageWhatsapp className="text-white shrink-0" />
      // </div>
    ),
    getProps: (item) => {
      return {
        to: "/settings/channels/facebook/" + item?.id,
        name: item?.description,
        description: "Página do Facebook",
        icon: <IconMageFacebookCircle className="text-[#0e5cdb] shrink-0 size-full" />,
      }
    },
  },
  {
    type: "instagram",
    code: "7",
    label: "Instagram",
    icon: (
      <div className="p-[2.5px]">
        <InstagramCircle className="shrink-0 size-full" />
      </div>
    ),
    getProps: (item) => {
      return {
        to: "/settings/channels/instagram/" + item?.id,
        name: item?.description,
        description: "Instagram Direct",
        icon: (
          <div className="p-[2.5px]">
            <InstagramCircle className="shrink-0 size-full" />
          </div>
        ),
      }
    },
  },
  {
    type: "widget",
    code: "10",
    label: "Widget",
    icon: (
      <div className="p-0.5">
        <div className="fc bg-[#08bcdf] rounded-full p-1 shrink-0 aspect-square">
          <IconMageMessageSquareFill className="text-white shrink-0 size-full" />
        </div>
      </div>
    ),
    getProps: (item) => {
      return {
        to: "/settings/channels/widget/" + item?.id,
        name: "Widget",
        description: "Chat no site",
        icon: (
          <div className="p-0.5">
            <div className="fc bg-[#08bcdf] rounded-full p-1 shrink-0 aspect-square">
              <IconMageMessageSquareFill className="text-white shrink-0 size-full" />
            </div>
          </div>
        ),
      }
    },
  },
  {
    type: "sms",
    code: "9",
    label: "SMS",
    icon: (
      <div className="p-0.5">
        <div className="fc bg-[#cf6ac0] rounded-full p-2 shrink-0 aspect-square">
          {/* <SmsIcon2 className="!fill-black !text-black [&_path]:!fill-black [&_path]:!text-black shrink-0 size-full" /> */}
          {/* <SmsIcon2 className="shrink-0 size-full !text-white fill-white" /> */}
          <SmsIcon4 className="shrink-0 size-full !text-white fill-white" />
        </div>
      </div>
    ),
    getProps: (item, workspace: IWorkspace) => {
      return {
        to: "/settings/channels/sms/" + item?.id,
        name: "SMS",
        description: (workspace?.sms_credits || 0) + " créditos",
        icon: (
          <div className="p-0.5">
            <div className="fc bg-[#cf6ac0] rounded-full p-2 shrink-0 aspect-square">
              {/* <SmsIcon2 className="!fill-black !text-black [&_path]:!fill-black [&_path]:!text-black shrink-0 size-full" /> */}
              {/* <SmsIcon2 className="shrink-0 size-full !text-white fill-white" /> */}
              <SmsIcon4 className="shrink-0 size-full !text-white fill-white" />
            </div>
          </div>
        ),
      }
    },
  },
  {
    type: "email",
    code: "5",
    label: "E-mail",
    icon: (
      <div className="p-0.5">
        <div className="fc bg-[#cf6a87] rounded-full p-[6px] shrink-0 aspect-square">
          <IconIcRoundEmail className="text-white shrink-0 size-full" />
        </div>
      </div>
    ),
    getProps: (item) => {
      return {
        to: "/settings/channels/email/" + item?.id,
        name: item?.name,
        description: item?.description,
        icon: (
          <div className="p-0.5">
            <div className="fc bg-[#cf6a87] rounded-full p-[6px] shrink-0 aspect-square">
              <IconIcRoundEmail className="text-white shrink-0 size-full" />
            </div>
          </div>
        ),
      }
    },
  },
  {
    type: "telegram",
    code: "2",
    label: "Telegram",
    icon: <IconMageTelegram className="text-[#26a4e2] shrink-0 size-full" />,
    getProps: (item) => {
      return {
        to: "/settings/channels/telegram/" + item?.id,
        name: item?.description,
        description: "Bot do telegram",
        icon: <IconMageTelegram className="text-[#26a4e2] shrink-0 size-full" />,
      }
    },
  },
  {
    type: "custom",
    code: "6",
    label: "Personalizado",
    icon: (
      <div className="p-0.5">
        <div className="fc outline outline-1 outline-solid outline-selected-active-more rounded-full p-[6px] shrink-0 aspect-square">
          <IconIconoirCubeDotsSolid className="shrink-0 size-full text-content-100" />
        </div>
      </div>
    ),
    getProps: (item) => {
      return {
        to: "/settings/channels/custom/" + item?.id,
        name: item?.description,
        description: (item as any)?.hashIdentifier,
        icon: (
          <div className="p-0.5">
            <div className="fc outline outline-1 outline-solid outline-selected-active-more rounded-full p-[6px] shrink-0 aspect-square">
              <IconIconoirCubeDotsSolid className="shrink-0 size-full text-content-100" />
            </div>
          </div>
        ),
      }
    },
  },
  {
    type: "mercado-livre",
    code: "8",
    label: "Mercado Livre",
    icon: (
      <div className="p-0.5">
        <img src={mlImg} alt="Mercado Livre" className="object-cover rounded-full shrink-0 size-full" />
      </div>
    ),
    getProps: (item) => {
      return {
        to: "/settings/channels/mercado-livre/" + item?.id,
        name: item?.description,
        description: "Loja do Mercado Livre",
        icon: (
          <div className="p-0.5">
            <img src={mlImg} alt="Mercado Livre" className="object-cover rounded-full shrink-0 size-full" />
          </div>
        ),
      }
    },
  },
  {
    type: "voip",
    code: "11",
    label: "Voip",
    icon: (
      <div className="p-0.5">
        <div className="fc bg-amber-300 rounded-full p-[8px] shrink-0 aspect-square g-icon-wrapper">
          <IconIcSharpPhoneInTalk className="shrink-0 size-full !text-black fill-black" />
        </div>
      </div>
    ),
    getProps: (item, workspace: IWorkspace) => {
      return {
        to: "/settings/channels/voip/" + item?.id,
        name: item?.description || "Voip",
        description: masks.cell(item?.phone),
        icon: (
          <div className="p-0.5">
            <div className="fc bg-amber-300 rounded-full p-[6px] shrink-0 aspect-square g-icon-wrapper">
              <IconIcSharpPhoneInTalk className="shrink-0 size-full !text-black fill-black" />
            </div>
          </div>
        ),
      }
    },
  },
]

// | "connected"
// | "disconnected"
// | "processing_channel"
// | "restarting_channel"
// | "login_required"
// | "restart_required"
// | "qr_code"
// | "invalid_credentials"
// | "invalid_code"
// | "challenge_required"
// | "recreate_required"

export enum ChannelStatusEnum {
  CONNECTED = "connected",
  DISCONNECTED = "disconnected",
  PROCESSING_CHANNEL = "processing_channel",
  RESTARTING_CHANNEL = "restarting_channel",
  LOGIN_REQUIRED = "login_required",
  RESTART_REQUIRED = "restart_required",
  QR_CODE = "qr_code",
  INVALID_CREDENTIALS = "invalid_credentials",
  INVALID_CODE = "invalid_code",
  CHALLENGE_REQUIRED = "challenge_required",
  RECREATE_REQUIRED = "recreate_required",
}
export const channelsDef = {
  array: channelsArray,
  record: channelsArray.reduce((acc, item) => {
    acc[item.type] = item
    return acc
  }, {}) as Record<string, ChannelDefItem>,
  recordByCode: channelsArray.reduce((acc, item) => {
    acc[item.code] = item
    return acc
  }, {}) as Record<string, ChannelDefItem>,
  statusEnum: ChannelStatusEnum,
  statusLabel: {
    [ChannelStatusEnum.CONNECTED]: "Conectado",
    [ChannelStatusEnum.DISCONNECTED]: "Desconectado",
    [ChannelStatusEnum.PROCESSING_CHANNEL]: "Processando",
    [ChannelStatusEnum.RESTARTING_CHANNEL]: "Reiniciando",
    [ChannelStatusEnum.LOGIN_REQUIRED]: "Login necessário",
    [ChannelStatusEnum.RESTART_REQUIRED]: "Reiniciar",
    [ChannelStatusEnum.QR_CODE]: "QR Code",
    [ChannelStatusEnum.INVALID_CREDENTIALS]: "Credenciais inválidas",
    [ChannelStatusEnum.INVALID_CODE]: "Código inválido",
    [ChannelStatusEnum.CHALLENGE_REQUIRED]: "Desafio necessário",
    [ChannelStatusEnum.RECREATE_REQUIRED]: "Necessário recriar",
  },
}
